import React, { useState, useEffect } from "react";
import "antd/dist/reset.css";
import Redeem from "./components/Redeem";
import { message } from "antd";
import Points from "./components/Points";
import User from "./components/User";
import WithdrawTable from "./components/WithdrawTable";
const Reward = () => {
  const [extrainfo, setExtraInfo] = useState(false);
  const [selectedReward, setSelectedReward] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const userinfo = user;

 const rewardData = [
    {
      img: "./images/reward1.png",
      rewardMethod: "cash",
      title: "UPI",
      rewardPrice: "₹100",
      points: 1000,
    },
    {
      img: "./images/reward2.jpg",
      title: "Payoneer",
      rewardMethod: "gift_card",
      rewardPrice: "₹100",
      points: 1000,
    },
    {
      img: "./images/reward3.jpg",
      rewardMethod: "gift_card",
      title: "Amazon INR",
      rewardPrice: "₹100",
      points: 1000,
    },
    {
      img: "./images/reward4.jpg",
      rewardMethod: "gift_card",
      title: "Flipkart",
      rewardPrice: "₹100",
      points: 1000,
    },
  ];

  const handleRewardClick = (reward) => {
    const userPoints = userinfo?.balance ?? 0;
    console.log("object", userinfo)
 setSelectedReward(reward);
      setExtraInfo(true);
    // if () {
    //   message.error(
    //     `You need a minimum of 1000 points to redeem a reward. Selected Reward: ${reward.title.toUpperCase()}`
    //   );
    // } else {
     
    // }
  };

  const redeemtoggle = () => {
    setExtraInfo((prev) => !prev);
  };

  return (
    <div>
  

      <div className="container dashboard-page mt-4 min-h">
        <User />
        <div className="">
        <div className="card p-4">
          <div className="redeem-main-header">
            <div className="text-ref">
              <h3 className="mb-0">
                You can redeem your reward with ease using gift vouchers or cash
                rewards.
              </h3>
            </div>
            <hr />
            <h3 className="h5 mt-4">
              Your current point is{" "}
              <span className="color1 h2">
                <Points />
                <span> PSP </span>
              </span>
            </h3>
            <div className="h1"></div>
          </div>

          <div className="row g-5 mt-3">
            {rewardData.map((item, index) => (
              <div
                className="col-lg-6 col-md-4 col-sm-6 col-12 "
                onClick={() => handleRewardClick(item)}
                key={index}
              >
                <div className="coupon-card">
                  <div className="coupon-body">
                    <div className="coupon-value">
                      <h6 className="coupon-brand">{item.title}</h6>
                      <h3 className="reward-amount">{item.rewardPrice}</h3>
                      <p className="coupon-label">COUPON</p>
                      <span className="terms-text">{item.points} PSP</span>
                    </div>
                    <div className="coupon-image">
                      <img src={item.img} alt={item.title} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <WithdrawTable />
        
        
        </div>

      </div>





      {extrainfo && (
        <Redeem reward={selectedReward} redeemtoggle={redeemtoggle} />
      )}
    </div>
  );
};

export default Reward;
